export const uniqueByKeys = <
    T extends Partial<Record<K, string[] | string | undefined | null>>, // Props can be optional
    K extends keyof T,
>(
    keys: K[],
    arr: T[] | null | undefined = []
): Record<K, string[]> => {
    if (arr == null) {
        return keys.reduce(
            (acc, key) => {
                acc[key] = [];
                return acc;
            },
            {} as Record<K, string[]>
        );
    }

    return keys.reduce(
        (acc, key) => {
            acc[key] = [
                ...new Set(
                    arr.flatMap((item) => {
                        const value = item[key];
                        if (value == null) return []; // Skip undefined or null values
                        return Array.isArray(value) ? value : [value]; // Convert single value to array
                    })
                ),
            ];
            return acc;
        },
        {} as Record<K, string[]>
    );
};
